import React from "react";
import { useTranslation } from "react-i18next";


const WhyChooseUsSection = ({siteConfig}) => {

  const { t } = useTranslation();

  
  return (
    <section className="container mx-auto px-6 py-16 text-center" id="why-choose-us">
   
      <h4 className="text-main-100 uppercase tracking-widest sec-head-font">
         {t('sections.advantages')}
      </h4>
      <h2 className="text-3xl sec-breif-font text-bf-100 mt-2">
      {t('sections.advantage_title')}
      </h2>
      <p className="text-dc-100 sec-desc-font mt-2 max-w-2xl mx-auto">
      {t('sections.advantage_description')}
      </p>

  
      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        {siteConfig.why_choose_us.map((advantage) => (
          <div
            key={advantage.id}
            className="flex flex-col items-center text-center"
          >
            <img src={advantage.icon} alt={advantage.title} className="h-[100px]"   />
            <h3 className="font-bold text-bf-100 text-lg p-3px mt-6">
              {advantage.title}
            </h3>
            <p className="text-dc-100 font-light mt-2 max-w-sm text-sm/5" >{advantage.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
